<template>
  <div>
    <div
      v-for="company in companies"
      class="mb-4"
    >
      <div class="media align-items-center">
        <img
          class="rounded-circle user-image border mr-2"
          :src="getPhoto(company.logo,'thumbnailCropped')"
          alt=""
          style="width: 60px"
        >
        <div class="about">
          <div class="name f-w-600">
            {{ company.name }} {{ getCompanyFormat(company.format) }}
          </div>

          <div
            style="cursor: pointer"
            class="text-left"
            @click.prevent="$emit('openRatingPopup',{company: company, profile: profile})"
          >
            <div v-if="profile === 'PROCUREMENT'">
              <StarRatingView
                :count="company.procurementRateCount"
                :total="company.procurementRateTotal"
              />
            </div>

            <div v-else-if="profile === 'SUPPLIER'">
              <StarRatingView
                :count="company.supplyRateCount"
                :total="company.supplyRateTotal"
              />
            </div>
            <div v-else>
              <StarRatingView
                :count="0"
                :total="0"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {getSectorCompanyList} from "@/repositories/GeneralDataRepository";
import {mapState} from "vuex";
import {getCompanyFormat, getPhoto} from "@/repositories/Utils";
import StarRatingView from "@/pages/scc/utils/StarRatingView.vue";

export default {
  name: 'SectorCompaniesModalContent',
  components: {StarRatingView},
  props:{
    sector: '',
    profile: '',
  },
  data(){
     return {
       companies: []
     };
  },
  computed:{
    ...mapState({
      token: state => state.auth.token
    })
  },
  mounted(){

    getSectorCompanyList(this.token, this.sector.id, this.profile ).then(list=>{

      this.companies = list;

    });

  },
  methods:{

    getPhoto(path, size) {
      return getPhoto(path, size);
    },
    getCompanyFormat(keyword) {
      return getCompanyFormat(keyword, this.$i18n.locale);
    },
  }


}
</script>
<style>
div.review canvas {
  position: relative !important;
}

div.review input {
  z-index: 1;
  display: inline-block;
}
</style>